import { render, staticRenderFns } from "./DesignBox.vue?vue&type=template&id=165c57cc&"
import script from "./DesignBox.vue?vue&type=script&lang=js&"
export * from "./DesignBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports